import React from 'react';
import { HelpListType } from './types';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'cokitchen-icons';

type Props = { list: HelpListType[] };

const ProfileHelp = ({ list }: Props) => {
  return (
    <div className='pt-7'>
      <label className='text-gray-9'>Help</label>
      <div className='space-y-4 mt-6'>
        {list?.map(({ label, route, isExternal }, i) =>
          isExternal ? (
            <a
              href={route}
              target='_blank'
              rel='noopener noreferrer'
              key={i}
              className='no-underline flex items-center pb-4 border-b border-gray-13'>
              <div className='flex flex-col grow cursor-pointer '>
                <label className='cursor-pointer hover:text-red-5 transition-all'>{label}</label>
              </div>
              <div>
                <ArrowRightIcon className='bg-[#F2F2F3] p-1 w-[24px] h-[24px] text-gray-9 rounded-full hover:bg-gray-4 hover:text-white transition-all' />
              </div>
            </a>
          ) : (
            <Link to={route} key={i} className={`flex items-center pb-4 border-b border-gray-13`}>
              <div className='flex flex-col grow cursor-pointer '>
                <label className='cursor-pointer hover:text-red-5 transition-all'>{label}</label>
              </div>
              <div>
                <ArrowRightIcon className='bg-[#F2F2F3] p-1 w-[24px] h-[24px] text-gray-9 rounded-full hover:bg-gray-4 hover:text-white transition-all' />
              </div>
            </Link>
          )
        )}
      </div>
    </div>
  );
};

export default ProfileHelp;
